import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PlayerConsentsService } from '../player-consents.service';
import { UpdatePlayerConsentDTO } from '../player-consents.model';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';

@Component({
  selector: 'player-consents-v2-component',
  templateUrl: './player-consents-v2.component.html',
  styleUrls: ['./player-consents-v2.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    DatePipe,
  ],
})
export class PlayerConsentsV2Component implements OnInit {
  fg: UntypedFormGroup;
  @Input() playerId: number;
  editMode = false;
  success = false;
  updatingInProgress = false;
  confirmationDate: string;
  dateUpdated: string;
  consentNotSet = false;

  constructor(
    private fb: UntypedFormBuilder,
    private service: PlayerConsentsService,
    private changesDetector: ChangeDetectorRef,
    private entityGroupService: EntityGroupDetailsService
  ) {}

  ngOnInit(): void {
    this.initialize();
    this.entityGroupService.isotopeLayout.next();
  }

  update() {
    this.updatingInProgress = true;
    const rawValue = this.fg.getRawValue();
    const updateDto: UpdatePlayerConsentDTO = {
      gamesSms: rawValue.gamesSms,
      gamesEmail: rawValue.gamesEmail,
      gamesCall: rawValue.gamesCall,
      lottoSms: rawValue.lottoSms,
      lottoEmail: rawValue.lottoEmail,
      lottoCall: rawValue.lottoCall,
    };
    this.service.updateV2(this.playerId, updateDto).subscribe(
      () => {
        this.toggleEditMode();
        this.fg.disable();
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 2000);
        this.updatingInProgress = false;
      },
      () => {
        this.success = false;
        this.updatingInProgress = false;
      }
    );
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.fg.enable();
    } else {
      this.initialize();
    }
  }

  private initialize() {
    this.service.get(this.playerId).subscribe({
      next: (d) => {
        this.consentNotSet = false;
        this.confirmationDate = d.confirmationDate;
        this.dateUpdated = d.dateUpdated;
        this.fg = this.fb.group({
          gamesSms: [d.gamesSms, Validators.required],
          gamesCall: [d.gamesCall, Validators.required],
          gamesEmail: [d.gamesEmail, Validators.required],
          lottoSms: [d.lottoSms, Validators.required],
          lottoCall: [d.lottoCall, Validators.required],
          lottoEmail: [d.lottoEmail, Validators.required],
        });
        this.changesDetector.detectChanges();
        this.fg.disable();
      },
      error: (err) => {
        if (err.error.code === 'error.consent.not.found') {
          this.consentNotSet = true;
        }
      },
    });
  }
}
